export default "__VITE_PUBLIC_ASSET__820a850e__"